import { createContext } from '@/utils';
import type { State } from './types';

export const MagicContext = createContext<State | undefined>(
  undefined,
  'MagicContext'
);
